module.exports = __webpack_public_path__ + "static/media/csv.a4f30949.png";